import { Chip } from "@mui/material";
import { grey, orange, red } from "@mui/material/colors";
import Txt from "../../typography/Txt";

const CellRendererPriority = ({
  value,
  fontSize = "11px",
  includePrefix = false,
}) => {
  if (!value) return <Txt secondary>—</Txt>;

  const priorityConfig = {
    Low: { color: grey[700], bg: grey[100] },
    Medium: { color: orange[700], bg: orange[50] },
    High: { color: red[700], bg: red[50] },
  };

  const config = priorityConfig[value] || priorityConfig.Medium;

  return (
    <Chip
      label={includePrefix ? `Priority: ${value}` : value}
      size="small"
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        fontWeight: 600,
        // width: "fit-content",
        // px: 1,
        fontSize: fontSize,
      }}
    />
  );
};

export default CellRendererPriority;
